import { render } from "./RequestHeadersTab.vue?vue&type=template&id=71b17228"
import script from "./RequestHeadersTab.vue?vue&type=script&lang=js"
export * from "./RequestHeadersTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__